import { ACTION_LOGOUT } from "@login/reducer/actions.type";
import {
  SET_CARD_STORE,
  SET_CARD_RESET,
  SET_LIMIT_4_NUMBER_DIGIT,
  FETCH_CARD_LIST_REQUEST,
  FETCH_CARD_LIST_SUCCESS,
  FETCH_CARD_LIST_FAILURE,
  FETCH_CARD_DETAIL_REQUEST,
  FETCH_CARD_DETAIL_SUCCESS,
  FETCH_CARD_DETAIL_FAILURE,
  FETCH_CARD_ACTIVATE_REQUEST,
  FETCH_CARD_ACTIVATE_SUCCESS,
  FETCH_CARD_ACTIVATE_FAILURE,
  FETCH_CARD_LOCK_UNLOCK_REQUEST,
  FETCH_CARD_LOCK_UNLOCK_SUCCESS,
  FETCH_CARD_LOCK_UNLOCK_FAILURE,
  FETCH_CARD_LOCK_UNLOCK_ONLINE_TRADING_REQUEST,
  FETCH_CARD_LOCK_UNLOCK_ONLINE_TRADING_SUCCESS,
  FETCH_CARD_LOCK_UNLOCK_ONLINE_TRADING_FAILURE,
  FETCH_CARD_FULL_NUMBER_REQUEST,
  FETCH_CARD_FULL_NUMBER_SUCCESS,
  FETCH_CARD_FULL_NUMBER_FAILURE,
  FETCH_CARD_HISTORY_REQUEST,
  FETCH_CARD_HISTORY_SUCCESS,
  FETCH_CARD_HISTORY_FAILURE,
  FETCH_CARD_STATEMENT_REQUEST,
  FETCH_CARD_STATEMENT_SUCCESS,
  FETCH_CARD_STATEMENT_FAILURE,
  FETCH_CARD_PHYSICAL_REGISTER_REQUEST,
  FETCH_CARD_PHYSICAL_REGISTER_SUCCESS,
  FETCH_CARD_PHYSICAL_REGISTER_FAILURE,
  FETCH_CARD_AUTHORIZATION_KEY_REQUEST,
  FETCH_CARD_AUTHORIZATION_KEY_SUCCESS,
  FETCH_CARD_AUTHORIZATION_KEY_FAILURE,
} from "./actions.type";

import { CardState, CardActions } from "./types";

const initialState: CardState = {
  statusListCard: "init",
  statusCardDetail: "init",
  resListCard: undefined,
  resCardDetail: undefined,
  resCardConfirm: undefined,
  statusCardConfirm: "init",
  resCardAuth: undefined,
  statusCardAuth: "init",
  cardNumFull: undefined,
  resCardStatement: undefined,
  statusCardStatement: "init",
  resCardHistory: undefined,
  statusCardHistory: "init",
  resCardPhysicalRegister: undefined,
  statusPhysicalRegister: "init",
  errorOTP: false,
  error: undefined,
  limit4NumDigit: undefined,
};

export default (state = initialState, action: CardActions): CardState => {
  switch (action.type) {
    case FETCH_CARD_LIST_REQUEST:
      return {
        ...state,
        statusListCard: "pending",
      };
    case FETCH_CARD_LIST_SUCCESS:
      return {
        ...state,
        resListCard: action.payload,
        statusListCard: "ok",
      };
    case FETCH_CARD_LIST_FAILURE:
      return {
        ...state,
        statusListCard: "error",
      };
    case FETCH_CARD_DETAIL_REQUEST:
      return {
        ...state,
        statusCardDetail: "pending",
      };
    case FETCH_CARD_DETAIL_SUCCESS:
      return {
        ...state,
        resCardDetail: action.payload,
        statusCardDetail: "ok",
      };
    case FETCH_CARD_DETAIL_FAILURE:
      return {
        ...state,
        statusCardDetail: "error",
      };

    case FETCH_CARD_ACTIVATE_REQUEST:
      return {
        ...state,
        resCardConfirm: undefined,
        statusCardConfirm: "pending",
        error: undefined,
      };
    case FETCH_CARD_ACTIVATE_SUCCESS:
      return {
        ...state,
        resCardConfirm: action.payload,
        statusCardConfirm: "ok",
      };
    case FETCH_CARD_ACTIVATE_FAILURE:
      return {
        ...state,
        statusCardConfirm: "error",
        error: action.payload,
      };

    case FETCH_CARD_LOCK_UNLOCK_REQUEST:
      return {
        ...state,
        resCardConfirm: undefined,
        statusCardConfirm: "pending",
      };
    case FETCH_CARD_LOCK_UNLOCK_SUCCESS:
      return {
        ...state,
        resCardConfirm: action.payload,
        statusCardConfirm: "ok",
      };
    case FETCH_CARD_LOCK_UNLOCK_FAILURE:
      return {
        ...state,
        statusCardConfirm: "error",
      };

    case FETCH_CARD_LOCK_UNLOCK_ONLINE_TRADING_REQUEST:
      return {
        ...state,
        resCardConfirm: undefined,
        statusCardConfirm: "pending",
      };
    case FETCH_CARD_LOCK_UNLOCK_ONLINE_TRADING_SUCCESS:
      return {
        ...state,
        resCardConfirm: action.payload,
        statusCardConfirm: "ok",
      };
    case FETCH_CARD_LOCK_UNLOCK_ONLINE_TRADING_FAILURE:
      return {
        ...state,
        statusCardConfirm: "error",
      };

    case FETCH_CARD_FULL_NUMBER_REQUEST:
      return {
        ...state,
        resCardConfirm: undefined,
        cardNumFull: undefined,
        statusCardConfirm: "pending",
      };
    case FETCH_CARD_FULL_NUMBER_SUCCESS:
      return {
        ...state,
        resCardConfirm: action.payload,
        statusCardConfirm: "ok",
      };
    case FETCH_CARD_FULL_NUMBER_FAILURE:
      return {
        ...state,
        statusCardConfirm: "error",
      };

    case FETCH_CARD_AUTHORIZATION_KEY_REQUEST:
      return {
        ...state,
        resCardAuth: undefined,
        statusCardConfirm: "init",
        statusCardAuth: "pending",
      };

    case FETCH_CARD_AUTHORIZATION_KEY_SUCCESS:
      return {
        ...state,
        statusCardAuth: "ok",
        resCardAuth: action.payload,
      };

    case FETCH_CARD_AUTHORIZATION_KEY_FAILURE:
      return {
        ...state,
        statusCardAuth: "error",
        errorOTP: action.errorOTP,
        error: action.payload,
      };

    case FETCH_CARD_STATEMENT_REQUEST:
      return {
        ...state,
        resCardStatement: undefined,
        statusCardStatement: "pending",
      };
    case FETCH_CARD_STATEMENT_SUCCESS:
      return {
        ...state,
        resCardStatement: action.payload,
        statusCardStatement: "ok",
      };
    case FETCH_CARD_STATEMENT_FAILURE:
      return {
        ...state,
        statusCardStatement: "error",
      };

    case FETCH_CARD_HISTORY_REQUEST:
      return {
        ...state,
        resCardHistory: undefined,
        statusCardHistory: "pending",
      };
    case FETCH_CARD_HISTORY_SUCCESS:
      return {
        ...state,
        resCardHistory: action.payload,
        statusCardHistory: "ok",
      };
    case FETCH_CARD_HISTORY_FAILURE:
      return {
        ...state,
        statusCardHistory: "error",
      };

    case FETCH_CARD_PHYSICAL_REGISTER_REQUEST:
      return {
        ...state,
        resCardPhysicalRegister: undefined,
        statusPhysicalRegister: "pending",
        error: undefined,
      };
    case FETCH_CARD_PHYSICAL_REGISTER_SUCCESS:
      return {
        ...state,
        resCardPhysicalRegister: action.payload,
        statusPhysicalRegister: "ok",
      };
    case FETCH_CARD_PHYSICAL_REGISTER_FAILURE:
      return {
        ...state,
        statusPhysicalRegister: "error",
        error: action.payload,
      };
    case SET_LIMIT_4_NUMBER_DIGIT:
      return {
        ...state,
        limit4NumDigit: action.payload,
      };
    case SET_CARD_STORE:
      return {
        ...state,
        ...action.payload,
      };
    case SET_CARD_RESET:
      return {
        ...initialState,
        resListCard: state.resListCard,
        limit4NumDigit: state.limit4NumDigit,
      };
    case ACTION_LOGOUT:
      return {
        ...initialState,
      };
    default:
      return {
        ...state,
      };
  }
};
